/* eslint-disable */
import AxiosService from '@/services/axios';
import LoaderService from '@/services/loader';
import { Inject, Service } from 'vue-di-container';

import ContractTemplateModel from '@/models/contractTemplateModel';
import { Result } from '../models/Result';
import contractCategoriesModel from '../models/contractCategoriesModel';
import { TemplateModel } from '../models/TemplateModel';
import { ContractModel, CreateContractModel } from '../models/contractDetailsModel';

@Service()
export default class ContractTemplateService {
  @Inject(AxiosService) public axiosService!: AxiosService;
  @Inject(LoaderService) public loaderService!: LoaderService;

  public async getTemplates(categoryId: number): Promise<Result<ContractTemplateModel[]>> {
    this.loaderService.ShowLoader();
    try {
      const url = `api/Contract?categoryId=${categoryId}`;
      const result = await this.axiosService.axiosInstance.get(url);
      this.loaderService.HideLoader();
      return result.data;
    } catch (e) {
      throw e;
    } finally {
      this.loaderService.HideLoader();
    }
  }
  public async getContractCategories(): Promise<Result<contractCategoriesModel[]>> {
    this.loaderService.ShowLoader();
    try {
      const url = `api/Contract/GetContractCategories`;
      const result = await this.axiosService.axiosInstance.get(url);
      this.loaderService.HideLoader();
      return result.data;
    } catch (e) {
      throw e;
    } finally {
      this.loaderService.HideLoader();
    }
  }

  public async getTemplateById(templateId: number): Promise<Result<TemplateModel>> {
    this.loaderService.ShowLoader();
    try {
      const url = `api/Contract/GetTemplateById?templateId=${templateId}`;
      const result = await this.axiosService.axiosInstance.get(url);
      return result.data;
    } catch (e) {
      throw e;
    } finally {
      this.loaderService.HideLoader();
    }
  }
}
